module.exports = __webpack_public_path__ + "img/approve.b9206eba.svg";